var IgrMultiColumnComboBoxTextChangedEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrMultiColumnComboBoxTextChangedEventArgs() {
    }
    Object.defineProperty(IgrMultiColumnComboBoxTextChangedEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrMultiColumnComboBoxTextChangedEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrMultiColumnComboBoxTextChangedEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrMultiColumnComboBoxTextChangedEventArgs.prototype, "oldText", {
        get: function () {
            return this.i.oldText;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrMultiColumnComboBoxTextChangedEventArgs.prototype, "newText", {
        get: function () {
            return this.i.newText;
        },
        enumerable: true,
        configurable: true
    });
    return IgrMultiColumnComboBoxTextChangedEventArgs;
}());
export { IgrMultiColumnComboBoxTextChangedEventArgs };
//# sourceMappingURL=igr-multi-column-combo-box-text-changed-event-args.js.map
